// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__fXIbQ","icon":"styles_icon__1wUaV","text":"styles_text__1b2bU"};